import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const CollectionLazy = loadable(() => import(/* webpackChunkName: "Collections" */ './CollectionSuspense'));

export const CollectionAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <CollectionLazy />
    </DelayedSuspense>
);
